import React from 'react'
import BotMessage from '../BotMessage'
import InnerBotAvatar from './InnerBotAvatar'
import chatScript from "../ChatScript.json"

import Functions from '../utils/Functions'

export default function BotSimpleMessage({ message, isLastBotMessage,  setIsTyping, messages, setMessages,urlBotImage }) {

    // Utilizzo di useRef per gestire il cleanup del timeout
    const timeoutRef = React.useRef(null)

    React.useEffect(() => {
        // console.log("BotSimpleMessage mounted: message.id=" + message.id)


        const processNextMessage = () => {
            const next =  Functions.getMessageById(message.prossima)

            if (next) {
                // Controlla se il messaggio successivo è già presente nell'elenco per evitare duplicazioni
                if (!messages.some(x => x.id === next.id)) {
                    setIsTyping(true)
                    timeoutRef.current = setTimeout(() => {
                        setIsTyping(false)
                        setMessages(prevMessages => [...prevMessages, { ...next, sender: 'bot' }])
                    }, next.delay || 1000) // Ritardo di 1 secondo
                }
            }
        }

        // Esegui la funzione definita per processare il prossimo messaggio
        processNextMessage()

        // Cleanup function per cancellare il timeout quando il componente viene smontato o le dipendenze cambiano
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [message.id, message.prossima, messages, setIsTyping, setMessages]) // Aggiunto `messages` e altri dipendenze pertinenti

    return (
        <div key={"bot" + message.id} className='grid'>
            <InnerBotAvatar urlBotImage={urlBotImage} message={message} isLastBotMessage={isLastBotMessage} />
            <div className='col-11'>
                <BotMessage msg={message} isLastBotMessage={isLastBotMessage}></BotMessage>
            </div>
        </div>
    )
}
